import { init, RematchDispatch, RematchRootState } from '@rematch/core'
import { models, RootModel } from 'src/models'



export const configureStore = preloadedState => {
    const store = init({
        models,
        redux: {
            devtoolOptions: {
                // disable redux devtools extension in the prod and preprod envirenement
                disabled: false
            },
            initialState: preloadedState
        }
    })

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('src/models', () => {
            const nextRootReducer = require('src/models').models
            // @ts-ignore
            store.replaceReducer(nextRootReducer)
        })
    }

    return store
}
// we add getState because it's node exposed in rematch
export type Store = ReturnType<typeof configureStore> & { getState: Function }
// @ts-ignore
export type Dispatch = RematchDispatch<RootModel>
export type RootState = RematchRootState<RootModel>
